import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export default function TextInput(
    {
        autoComplete = 'new-password',
        errorMessage,
        focusOnLoad,
        id,
        isValid,
        label,
        name,
        maxLength,
        onChange,
        onKeyPress,
        placeholder,
        readonly,
        required,
        showError,
        showLoader,
        tabIndex,
        type = 'text',
        value = '',
        onClick
    }) {
    const [t] = useTranslation();
    const [textValue, setTextValue] = useState(value);
    const inputRef = useRef(null);
    const displayError = required && !isValid || showError;
    const errorClasses = ' is-invalid border-danger';

    // set focus to input field if needed
    useEffect(() => {
        if (focusOnLoad) {
            inputRef.current.focus();
        }
    }, []);

    // handle change on text value and call external onChange if available
    function handleChange(newValue) {
        if (onChange) {
            onChange(newValue);
        }
        setTextValue(newValue);
    }

    useEffect(() => {
        setTextValue(value);
    }, [value]);

    return (
        <div className="form-group" onClick={onClick}>
            {label &&
            <label htmlFor={id}>
                {`${label}` /* Remove * ${required ? '*' : ''}*/}
                {
                    maxLength &&
                    <span className="small text-muted">{`  (${t('Validation.MAX_LENGTH', {count: maxLength})})`}</span>
                }
            </label>
            }
            <div className={`input-group${displayError ? errorClasses : ''}`}>
                <input
                    id={id}
                    type={type}
                    name={name}
                    value={textValue || ''}
                    placeholder={placeholder}
                    onChange={(event) => handleChange(event.target.value)}
                    readOnly={readonly}
                    onKeyPress={onKeyPress}
                    maxLength={maxLength}
                    autoComplete={autoComplete}
                    className={`form-control${displayError ? errorClasses : ''}`}
                    ref={inputRef}
                    tabIndex={tabIndex}
                />
                {
                    showLoader &&
                    <div className="input-group-append">
                        <span className="input-group-text">
                        <FontAwesomeIcon icon="spinner" className="fa-spin"/>
                        </span>
                    </div>
                }
            </div>
            {
                displayError &&
                <div className="invalid-feedback">
                    {errorMessage ? errorMessage : t('Validation.REQUIRED')}
                </div>
            }
        </div>
    );
}
